import { lazy, Suspense } from "react";
import { getTenant } from "../../theme";
import MainSpinner from "../../components/Spinner";
import useFlowInitialization from "../../hooks/useFlowInitialization";

const RejeemStepper = lazy(() => import("../../components/Join/rejeem/Stepper"));
const WhiteLabelStepper = lazy(() => import("../../components/Join/whiteLabel/Stepper"));

export default function Join() {
  const tenant = getTenant();

  // Initialize flow - resets index if coming from different flow
  useFlowInitialization('join');

  const StepperComponent = tenant.name === "rejeem" ? RejeemStepper : WhiteLabelStepper;

  return (
    <Suspense
        fallback={
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <MainSpinner />
          </div>
        }
      >
      <StepperComponent />
    </Suspense>
  );
}
